import React, {
  ChangeEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import Loader from '../../molecules/Loader';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import NoTabsData from '../../molecules/NoTabsData';
import {
  generateQuarterTabs,
  monthOptions,
} from '../../../core-utils/helper-utils/experienceHelper';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import properties from '../../../core-utils/properties';
import axios from 'axios';
import { useStores } from '../../../stores';
import {
  formatRiskTableExp,
  getReportName,
} from '../../../core-utils/helper-utils/riskRegisterHelper';
import { cellStyles1 } from '../../molecules/PatientDetailsMedicalHistoryTab';
import NoContent from '../../atoms/Icons/NoContent';
import Snackbar from '../../atoms/Snackbar';
import RiskRegisterConstants from '../../../core-utils/messages/RiskRegisterConstants';
import RiskDetailsWindow from '../RiskDetailsWindow';
import useSnackbar from '../../../core-utils/custom-hooks/Snackbar';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
} from '../../../core-utils/routes';
import { handleDownloadReport } from '../../../core-utils/helper-utils/contractReportHelper';
import { useNavigate } from 'react-router-dom';
import { BasicModal as BasicModal1 } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

type InsightsProps = {
  renewalMonth: string;
  incurredStartDate?: any;
  incurredEndDate?: any;
  paidStartDate?: any;
  paidEndDate?: any;
  isPlanDatesFetched?: any;
  aggregationParameter?: any;
};

const useStyles = makeStyles()({
  tab: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'left',
    paddingLeft: '16px',
  },
  selectedTab: {
    backgroundColor: `${patientAccessTheme.palette.grey[100]}`,
  },
  noDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '540px',
    border: '1px solid #E5E9F0',
    borderRadius: '4px',
  },
  quarterContainer: {
    marginTop: '10px',
    backgroundColor: '#fff',
    border: '1px solid #E5E9F0',
    borderRadius: 4,
    width: '100%',
    height: '90%',
  },
  tabsContainer: {
    borderBottom: '1px solid #e5e7eb',
  },
  tableConatiner: {
    width: '100%',
    maxHeight: '500px',
    overflowY: 'auto',
  },
  noTableDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '480px',
  },
});

const InsightsTab: React.FC<InsightsProps> = ({
  renewalMonth,
  incurredStartDate,
  incurredEndDate,
  paidStartDate,
  paidEndDate,
  aggregationParameter,
}) => {
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;
  const [tablePageSize] = useState<number>(6);
  const [riskTableData, setRiskTableData] = useState<any>([]);
  const hasSetQuarterIndex = useRef(false);
  const navigate = useNavigate();
  const messages = RiskRegisterConstants.MAIN_PAGE;

  const [tablePageNumber, setTablePageNumber] = useState<number>(1);
  // Loaders
  const [loading, setLoading] = useState(false);
  const [mainLoader] = useState<any>(<Loader height="400px" />);
  // risk modal
  const [isRiskModalOpen, setIsRiskModalOpen] = useState(false);
  const [activeRisk, setActiveRisk] = useState<any>(null);
  const [selectedRiskId, setSelectedRiskId] = useState<string>('');
  const [deletePopUpOpen, setDeletePopUpOpen] = useState<boolean>(false);

  // sanack bar state
  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();

  // Risk Table Column
  const NEW_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Insight',
      cellStyles: cellStyles1,
      align: 'left',
      width: '300px',
    },
    {
      name: 'Impact',
      cellStyles: cellStyles1,
      align: 'left',
      width: '300px',
    },
    {
      name: 'Date Recorded',
      cellStyles: cellStyles1,
      align: 'left',
      width: '200px',
    },
    {
      name: 'Status',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
  ];

  // monthly quaters
  // const quarterTabs = useMemo(() => generateQuarterTabs(renewalMonth), [
  //   renewalMonth,
  // ]);
  const today = new Date();
  const currentMonth = today.getMonth(); // August = 7
  const renewalMonthIndex = monthOptions.findIndex(
    (m) => m.toLowerCase() === renewalMonth.toLowerCase(),
  );

  // If the renewal month is in the future (e.g., Sep while today is Aug), use previous year
  const baseYear =
    renewalMonthIndex > currentMonth
      ? today.getFullYear() - 1
      : today.getFullYear();

  const quarterTabs = useMemo(
    () => generateQuarterTabs(renewalMonth, baseYear),
    [renewalMonth],
  );
  const [quarterIndex, setQuarterIndex] = useState<number | null>(null);

  // functions

  // handle risk click
  const handleRiskRowClick = (risk: any) => {
    setActiveRisk(risk);
    setIsRiskModalOpen(true);
  };

  // handle quater change
  const handleQuarterChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setQuarterIndex(newValue);
  };

  // handlePagination
  const handlePagination = (_event: ChangeEvent<unknown>, page: number) => {
    setTablePageNumber(page);
  };

  // handle risk click
  const handleRiskClick = (risk: any) => {
    // onRiskClick(risk);
    handleRiskRowClick(risk);
  };

  const handleMenuItem = (index: number, item: any) => {
    const riskId = riskTableData[index][0];
    switch (item) {
      case 'Delete':
        setSelectedRiskId(riskId);
        setDeletePopUpOpen(true);
        break;
    }
  };
  const handleUpdateRisk = async (data: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'files') {
        continue;
      } // handle files separately below

      const value = data[key];

      if (Array.isArray(value)) {
        if (value.length && typeof value[0] === 'object') {
          // For arrays of objects like `activity`
          formData.append(key, JSON.stringify(value));
        } else {
          // For arrays of strings like `impact`, `owner`
          value.forEach((item: any, index: number) => {
            formData.append(`${key}[${index}]`, item);
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // In case any single object sneaks in
        formData.append(key, JSON.stringify(value));
      } else if (value !== '') {
        formData.append(key, value); // Only append non-empty values
      }
    }
    formData.append(
      'eg_nid',
      employerGroupStore.employerGroupResponseData.eg_nid[0],
    );
    formData.append(
      'employer',
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
    );
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach((file: File) => {
        formData.append('files', file);
      });
    }
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.riskRegisterBaseUrl +
          properties.updateRisk,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((res) => {
        if (res.status === 200) {
          fetchAllInsightsData();
          openSnackbar('Risk has been updated', 'success', 6000);
          setIsRiskModalOpen(false);
        }
      })
      .catch(() => {
        openSnackbar('Failed to update risk', 'error', 3000);
      });
  };

  const handleNavigate = (
    contract: any,
    report: any,
    compare_agreement_id: any,
    openSnackbar: any,
  ) => {
    let path = '';
    switch (report) {
      case 'Gag Clause Compliance Check':
        path = GAG_CLAUSE_REPORT;
        break;
      case 'Provision Favorability Check':
        handleDownloadReport(
          'provisionMatrixReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          openSnackbar,
        );
        return;
      case 'Compensation Transparency Check':
        path = COMPENSATION_TRANSPARENCY_REPORT;
        break;
      case 'Inter-Contract Compliance Stop Loss and ASA':
      case 'Gap Analysis Check Plan Document and ASA':
      case 'Gap Analysis Check Plan Document and PBM':
        path = INTER_CONTRACT_REPORT;
        break;
      case 'Commercial Evaluation':
        handleDownloadReport(
          'feeEvaluationReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          openSnackbar,
        );
        return;
      default:
        return;
    }
    navigate(path, {
      state: {
        reportName: getReportName(report),
        document: `${contract?.health_care_partner_id?.health_care_partner} ${contract?.health_care_partner_id?.service_agreement_id?.service_agreement_name} Service Agreement`,
        healthcarePartner:
          contract?.health_care_partner_id?.health_care_partner,
        contract:
          contract?.health_care_partner_id?.service_agreement_id
            ?.service_agreement_name,
        contractId: contract._id,
        isContract: true,
        isReportsTab: true,
        compareId: compare_agreement_id?._id,
      },
    });
  };

  const deleteRisk = async () => {
    openSnackbar('Insight deletion in progress', 'info', 2000);
    const data = {
      risk_id: selectedRiskId,
      deleted: true,
    };
    await handleUpdateRisk(data);
    openSnackbar('Insight has been deleted', 'success', 6000);
  };

  // Apis
  // fetch all insights data
  const fetchAllInsightsData = async () => {
    try {
      if (quarterIndex === null) {
        return;
      }
      setLoading(true);
      await axios
        .post(
          properties.aiqBaseUrl +
            properties.riskRegisterBaseUrl +
            properties.getRiskByQuarter,
          {
            eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
            quarterMonths: quarterTabs[quarterIndex]?.months,
            page: tablePageNumber,
            limit: tablePageSize,
          },
        )
        .then((res: any) => {
          if (res.status === 200) {
            const risks = res.data.data.risks;
            const formattedRisks = formatRiskTableExp(risks, handleRiskClick);
            setRiskTableData(formattedRisks);
          }
        });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllInsightsData();
  }, [
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    tablePageNumber,
    quarterIndex,
  ]);

  useEffect(() => {
    setTablePageNumber(1);
  }, [quarterIndex]);

  useEffect(() => {
    if (
      hasSetQuarterIndex.current ||
      !renewalMonth ||
      quarterTabs.length === 0
    ) {
      return;
    }
    const currentMonthIndex = new Date().getMonth();
    const currentMonthName = monthOptions[currentMonthIndex];
    // First try current month match
    const matchIndex = quarterTabs.findIndex((q) =>
      q.months.some(
        (m) => m.month.toLowerCase() === currentMonthName.toLowerCase(),
      ),
    );

    if (matchIndex !== -1) {
      setQuarterIndex(matchIndex);
    } else {
      // Fallback: derive from renewal month
      const renewalMonthIndex = monthOptions.findIndex(
        (m) => m.toLowerCase() === renewalMonth.toLowerCase(),
      );
      const fallbackIndex = Math.floor(renewalMonthIndex / 3);
      setQuarterIndex(fallbackIndex !== -1 ? fallbackIndex : 0);
    }
    hasSetQuarterIndex.current = true;
  }, [renewalMonth, quarterTabs]);

  // Custom Tab panel
  const TabPanel = ({ children, value, index }: any) => {
    return value === index ? <Box>{children}</Box> : null;
  };

  return loading ? (
    mainLoader
  ) : (
    <Grid>
      <Grid
        container
        className={classes.quarterContainer}
        sx={{
          flexDirection: 'column',
        }}
      >
        <Grid className={classes.tabsContainer} size={12}>
          <Tabs
            value={quarterIndex}
            onChange={handleQuarterChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {quarterTabs?.map((q, idx) => (
              <Tab
                key={idx}
                className={classes.tab}
                classes={{ selected: classes.selectedTab }}
                label={
                  <Typography
                    fontSize="12px"
                    styleProps={{
                      color: idx === quarterIndex ? '#2E2F33' : '#596180',
                      textAlign: 'left',
                    }}
                  >
                    {q.label}
                  </Typography>
                }
              />
            ))}
          </Tabs>
        </Grid>
        {quarterTabs?.map((q, idx) => {
          return (
            <TabPanel value={quarterIndex} index={idx} key={q.label}>
              <Grid className={classes.tableConatiner}>
                {riskTableData?.length > 0 ? (
                  <BasicTable
                    columns={NEW_RISK_TABLE_COLUMNS}
                    rowsData={riskTableData}
                    hideColumnIndex={0}
                    showPagination={true}
                    handlePagination={handlePagination}
                    tableBodyStyles={{
                      borderBottom: 'none',
                    }}
                    isFullTable={true}
                    isMenuAvailable={true}
                    handleCellMenuItem={handleMenuItem}
                    menuOptions={RiskRegisterConstants.MAIN_PAGE.TABLE_MENU}
                    displayType="row"
                  />
                ) : (
                  <Grid className={classes.noTableDataContainer}>
                    <NoTabsData
                      icon={<NoContent />}
                      label="No Insights to show"
                    />
                  </Grid>
                )}
              </Grid>
            </TabPanel>
          );
        })}
      </Grid>
      {isRiskModalOpen && (
        <Grid
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
          onClick={() => setIsRiskModalOpen(false)}
        >
          <div
            style={{ height: '100%', backgroundColor: '#fff' }}
            onClick={(e) => e.stopPropagation()}
          >
            <RiskDetailsWindow
              risk={activeRisk}
              setDetailsWindowOpen={setIsRiskModalOpen}
              handleSave={handleUpdateRisk}
              handleOpenSnackBar={openSnackbar}
              handleActivityClick={() => {}}
              handleNavigate={handleNavigate}
            />
          </div>
        </Grid>
      )}

      {deletePopUpOpen && (
        <BasicModal1
          open={deletePopUpOpen}
          title={messages.DELETE}
          body={
            <Typography
              fontSize="12px"
              lineHeight="17px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="0px 0px 15px 0px"
            >
              {messages.DELETE_DESC}
            </Typography>
          }
          cancelButtonLabel={messages.CANCEL}
          confirmButtonLabel={messages.CONFIRM}
          handleCancel={() => setDeletePopUpOpen(false)}
          handleConfirm={() => {
            deleteRisk();
            setDeletePopUpOpen(false);
          }}
          handleClose={() => setDeletePopUpOpen(false)}
        />
      )}

      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
};

export default InsightsTab;
